module.exports = __webpack_public_path__ + "static/media/employees.bee7ea34.svg";